module.exports = __webpack_public_path__ + "img/check-yellow.887c148a.svg";